function kruxCallback(/* err */) {
    // TODO: error logging
}
const kruxPageView = {
    pageView: true
};

export default () => {
    if (window.Krux) {
        window.Krux('ns:mansueto', 'page:load', kruxCallback, kruxPageView); // eslint-disable-line new-cap
    }
};
